import { render, staticRenderFns } from "./AboutUsNew.vue?vue&type=template&id=3b2df125&scoped=true&"
import script from "./AboutUsNew.vue?vue&type=script&lang=js&"
export * from "./AboutUsNew.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsNew.vue?vue&type=style&index=0&id=3b2df125&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2df125",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
